<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="$emit('close')">
    <div class="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
      <div class="flex justify-between items-start mb-4">
        <h2 class="text-xl font-bold">{{ profile ? 'Edit Profile' : 'Add New Profile' }}</h2>
        <button @click="$emit('close')" class="text-gray-500 hover:text-gray-700">
          <XMarkIcon class="w-6 h-6" />
        </button>
      </div>
      
      <form @submit.prevent="save" class="space-y-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Name *</label>
            <input v-model="form.name" type="text" class="input w-full" required />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Relationship</label>
            <input v-model="form.relationship" type="text" class="input w-full" placeholder="Mother, Father, etc." />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Phone *</label>
            <input v-model="form.phone" type="tel" class="input w-full" required />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Age Range</label>
            <select v-model="form.age_range" class="input w-full">
              <option value="">Select age range</option>
              <option value="65-70">65-70</option>
              <option value="71-75">71-75</option>
              <option value="76-80">76-80</option>
              <option value="81-85">81-85</option>
              <option value="86+">86+</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Preferred Call Time</label>
            <input v-model="form.preferred_call_time" type="time" class="input w-full" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Avatar</label>
            <select v-model="form.avatar" class="input w-full">
              <option value="👵">👵 Grandmother</option>
              <option value="👴">👴 Grandfather</option>
              <option value="👤">👤 Generic</option>
            </select>
          </div>
        </div>
        
        <div class="flex justify-end space-x-2">
          <button type="button" @click="$emit('close')" class="btn btn-secondary">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary">
            {{ profile ? 'Update' : 'Create' }} Profile
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'

const props = defineProps({
  profile: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['close', 'save'])

const form = ref({
  name: '',
  relationship: '',
  phone: '',
  age_range: '',
  preferred_call_time: '',
  avatar: '👵'
})

onMounted(() => {
  if (props.profile) {
    form.value = { ...props.profile }
  }
})

function save() {
  emit('save', form.value)
}
</script>